module.exports = __webpack_public_path__ + "static/media/goods5.47dafa88.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods5.png
// module id = 1232
// module chunks = 0